import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-koenig',
  templateUrl: './koenig.component.html',
  styleUrls: ['./../app.component.css']
})
export class KoenigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
